import { Injectable } from '@angular/core';
import { HomeScreenElement } from 'src/app/classes/json-interface';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { LoggedUserService } from '../loged-user/loged-user.service';
import routerPath, {RouterPathUtility} from '../../classes/router-path';

/**
 * Gere le comportement des bouton pour acceder au différente pages de l'application
 */
@Injectable({
  providedIn: 'root'
})
export class MenuButtonService {

  constructor(private mRouter: Router,
              private mDialog: MatDialog,
              private mLoggedUser: LoggedUserService) { }

  /**
   * Constitue les boutons de la home page en fonction
   * des autorisation de la personne actuelement connectée
   *
   * SITE/CUST
   * EMPLOYE
   * ADMIN
   */
  public getArrayMenuItem(): HomeScreenElement[] {
    return [
      ...this.getArrayMenuItemClientSite(),     // Enregistre les element lors de la connection en tant que client/chantier
      ...this.getArrayMenuItemUser(),           // Enregistre les element lors de la connection en tant utilisateur d'armaor
      ...this.getArrayMenuItemAdministrator()   // Enregistre les elements lors de la connection en tant qu'admin
    ];
  }

  private getArrayMenuItemClientSite(): HomeScreenElement[] {
    return [
      {
        visible: this.mLoggedUser.rightShowOverview,
        title: 'Vue d\'ensemble', imageSrc: '/assets/icons/Overview.png',
        content: 'Aperçu de votre chantier.',
        onClickEventFunc: () => this.mRouter.navigateByUrl(routerPath.overview),
      },
      {
        visible: this.mLoggedUser.rightShowWebInput,
        title: 'Saisie en ligne', imageSrc: '/assets/icons/Commande.png',
        content: 'Saisissez des listes d\'aciers et commandez-les.',
        onClickEventFunc: () => this.mRouter.navigateByUrl(routerPath.myOrders),
      },
      {
        visible: this.mLoggedUser.rightShowWebSiteFollowup,
        title: 'Suivi chantier', imageSrc: '/assets/icons/Orders.png',
        content: 'Suivez l\'avancement de votre chantier.',
        onClickEventFunc: () => this.mRouter.navigateByUrl(routerPath.siteFollowUp),
      },
      {
        visible: this.mLoggedUser.RightShowDeliveryList,
        title: 'Mes Bons de livraison', imageSrc: '/assets/icons/BL.png',
        content: 'Consultez et téléchargez vos bons de livraisons.',
        onClickEventFunc: () => this.mRouter.navigateByUrl(routerPath.myDeliveryNote),
      },
      {
        visible: this.mLoggedUser.RightShowCertif,
        title: 'Certificates', imageSrc: '/assets/icons/certif.png',
        content: 'See and download the cast numbers certificates.',
        onClickEventFunc: () => this.mRouter.navigateByUrl(routerPath.myCertificats),
      },
      {
        visible: this.mLoggedUser.RightShowInvoiceList,
        title: 'Mes factures', imageSrc: '/assets/icons/invoice.png',
        content: 'Consultez et téléchargez vos factures.',
        onClickEventFunc: () => this.mRouter.navigateByUrl(routerPath.myInvoice),
      },
      {
        visible: this.mLoggedUser.rightShowOrderList,
        title: 'Liste des contrats', imageSrc: '/assets/icons/Printing list blue.png',
        content: 'Liste des contrats',
        onClickEventFunc: () => this.mRouter.navigateByUrl(routerPath.printingList),
      }
    ];
  }

  private getArrayMenuItemUser(): HomeScreenElement[] {
    return [
      ...this.getDashBoardHomeScreenItem(),
      {
        visible: this.mLoggedUser.RightShowDataList,
        title: 'Liste', imageSrc: '/assets/icons/Printing list.png',
        content: 'Liste',
        onClickEventFunc: () => this.mRouter.navigateByUrl(routerPath.printingList),
      },
      {
        visible: this.mLoggedUser.RightShowSupervisor,
        title: 'Superviseur', imageSrc: '/assets/icons/Supervisor.png',
        content: 'Superviseur',
        onClickEventFunc: () => this.mRouter.navigateByUrl(routerPath.supervisor),
      },
      {
        visible: this.mLoggedUser.RightShowDataList,
        title: 'Observateur d\'événements', imageSrc: '/assets/icons/spy-man.png',
        content: 'Observateur d\'événements',
        onClickEventFunc: () => this.mRouter.navigateByUrl(routerPath.eventObserver),
      },
      {
        visible: this.mLoggedUser.RightShowStock,
        title: 'Stock', imageSrc: '/assets/icons/packages.png',
        content: 'Afficher le stock',
        onClickEventFunc: () => this.mRouter.navigateByUrl(routerPath.stock),
      }
    ];
  }

  private getArrayMenuItemAdministrator(): HomeScreenElement[] {
    return [
      {
        visible: this.mLoggedUser.IsSuperAdmin,
        title: 'Query editor', imageSrc: '/assets/icons/Blank.png',
        content: 'Send SQL to server',
        onClickEventFunc: () => this.mRouter.navigateByUrl(routerPath.queryEditor),
      },
      {
        visible: this.mLoggedUser.IsSuperAdmin,
        title: 'Manage session', imageSrc: '/assets/icons/Blank.png',
        content: 'Manage session',
        onClickEventFunc: () => this.mRouter.navigateByUrl(routerPath.sessionManagment),
      }
    ];
  }

  /**
   * Genere les différent dashboard disponible pour l'utilisateur connecter
   */
  private getDashBoardHomeScreenItem(): HomeScreenElement[] {
    const arrayOfDashBoard = this.mLoggedUser.arrayDashBoard;
    if (!arrayOfDashBoard) return [];
    const arrayHomeScreenElement: HomeScreenElement[] = [];
    for (let i = 0; i < arrayOfDashBoard.length; i++) {
      if (arrayOfDashBoard[i].NoDash == undefined)
        continue;
      arrayHomeScreenElement.push({
        visible: true,
        title: arrayOfDashBoard[i].Name, imageSrc: '/assets/icons/Dashboard.png',
        content: '',
        onClickEventFunc: () => this.mRouter.navigateByUrl(RouterPathUtility.getDashBoardId(arrayOfDashBoard[i].NoDash))
      });
    }
    return arrayHomeScreenElement;
  }
}
